import styled from "styled-components";
import { motion } from "motion/react";

import Button from "Utilities/Button";
import useWizard from "./useWizard";

const staggerWithDelay = {
  animate: { transition: { delayChildren: 0.65, staggerChildren: 0.15 } },
  exit: { transition: { staggerChildren: 0.1 } },
};

const staggerNoDelay = {
  animate: { transition: { staggerChildren: 0.15 } },
  exit: { transition: { staggerChildren: 0.1 } },
};

const fadeUp = {
  initial: { opacity: 0, y: 50 },
  animate: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 150, damping: 15 } },
  exit: { opacity: 0, y: -80 },
};

export default function WizardIntro() {
  const { setShowOverview, closeWizard, hasLeftIntroRef } = useWizard();
  return (
    <Wrapper
      as={motion.div}
      variants={hasLeftIntroRef.current ? staggerNoDelay : staggerWithDelay}
      initial="initial"
      animate="animate"
    >
      <Top>
        <Title as={motion.div} variants={fadeUp} transition={{ duration: 0.35 }} className="merri">
          RE has never been easier.
        </Title>
        <Text as={motion.div} variants={fadeUp} transition={{ duration: 0.35 }} className="raleway">
          We'll walk you through everything you need to get your Religous
          Education Signup setup. <em>RE</em>lax - we've got you!
        </Text>
      </Top>
      <Buttons as={motion.div} variants={fadeUp} transition={{ duration: 0.35 }}>
        <BackButton onClick={closeWizard}>
          <span>Cancel</span>
        </BackButton>
        <Button onClick={() => setShowOverview(true)}>
          Get started <i className="fas fa-arrow-right" />
        </Button>
      </Buttons>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  padding: 80px;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const Top = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
`;

const Title = styled.div`
  font-size: 64px;
`;

const Text = styled.div`
  font-size: 28px;
  max-width: 540px;
`;

const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const BackButton = styled.button`
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 15px;
  color: #6b7280;
  padding: 8px 10px 8px 8px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: inherit;
  margin-right: auto;
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: #e5e7eb;
    color: #016099;
  }

  &:active {
    background: #016099;
    color: #fff;

    > span {
      transform: scale(0.85);
    }
  }

  > span {
    display: flex;
    align-items: center;
    gap: 4px;
    transition: transform 0.2s;
  }

  i {
    font-size: 1em;
    margin-right: 2px;
  }
`;
